<template>
  <div
    class="outsidePage"
    @click="goWeixin"
    v-stat.brow="{ tag: 'outsidepage.brow|端外页曝光', ext: biExt }"
    :style="{ backgroundImage: `url(${bgImgUrl})` }"
    >
      <Button class="btn" size="large">{{ btnText }}</Button>
  </div>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';
import { url } from '@tencent/ppd-base-libs';
import { Button } from '@tencent/wphk-design';
import { isTencentCharity } from '@/business/helper';

export default defineComponent({
  components: {
    Button,
  },
  setup() {
    const onameMap = {
      22: '全城街馬',
      21: '善導會',
      20: '鄰舍輔導會',
      19: '培幼會 PlanHK',
      18: '仁愛堂',
      16: '兒童醫健基金會',
      15: '愛望基金',
      14: '協康會',
      12: '地球之友',
      11: '苗圃行動',
      10: '保良局',
      9: '香港公益金',
      8: '香港小母牛',
      7: '護苗基金（ECSAF）',
      6: '惜食堂',
      5: '香港救助兒童會',
      4: '樂施會(OXFAM)',
      3: '東華三院',
      2: '奧比斯 (Orbis)',
      1: 'UNICEF',
      24: '成長希望基金會',
      26: '家福會',
      13: '香港單親協會',
      23: '香港心理衛生會',
      30: '九龍樂善堂',
      27: '共享基金會',
      29: '仁濟醫院',
      28: '博愛醫院',
      33: '香港聖公會福利協會',
      32: '香港世界宣明會',
      31: '香港防癌會',
    };
    const btnText = computed(() => {
      const oid = url.getUrlParam('oid');
      return oid && onameMap[oid] ?  `立即支持${onameMap[oid]}` : '立即前往';
    });
    const biExt = {
      fopenid: 'opened@wx.hkg',
      fuin: 'opened@wx.hkg',
      foid: url.getUrlParam('oid'),
    };
    const goWeixin = () => {
      window.location.href = 'weixin://';
    };

    const bgImgUrl = computed(() => (isTencentCharity() ? require('@/assets/tencent-charity/outsideWx.png') : require('@/assets/outside-wx/outsideWx.png')));

    return {
      btnText,
      biExt,
      bgImgUrl,
      goWeixin,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) url('~@/less/main');

.outsidePage {
  width: 100%;
  height: 1230/@rem;
  background: url(~@/assets/outside-wx/outsideWx.png) 0 0 no-repeat;
  background-size: contain;
  background-position: 0 0;
  z-index: 1000;
  text-align: center;

  .btn {
    background-color: @red-100-solid;
    margin: 850/@rem auto 0 auto;
  }
}
</style>
